import {
    ComponentServices,
    createRegisterableComponent,
} from '@news-mono/web-common'
import React from 'react'
import { useLocation } from 'react-router'
import { VideoHub } from '.'
import { CollectionRouteProps } from '..'
import { ThemeMargins } from '../__styling'

const getVideoInfoFromRouteResolution = (services: ComponentServices) => {
    if (services.resolution.type !== 'server') {
        throw new Error('Videos must be server resolved')
    }

    if (
        services.resolution.resolution.type !== 'video' &&
        services.resolution.resolution.type !== 'video-topic'
    ) {
        throw new Error(
            'Server resolution is not video, should not be rendering video',
        )
    }

    if (services.resolution.resolution.type === 'video-topic') {
        return {
            videoMeta: services.resolution.resolution.videoMeta,
        }
    }

    // collate resolved url slug video with related videos to return single video array
    const currentVideoMeta = services.resolution.resolution.videoMeta
    const relatedVideoMeta = services.resolution.resolution.relatedMeta
    const videoMeta = [currentVideoMeta].concat(relatedVideoMeta)

    return {
        videoMeta: videoMeta,
    }
}

export interface VideoHubRouteProps extends CollectionRouteProps {
    adUnitPath?: string
    verticalSpacing?: keyof ThemeMargins
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
}

export const VideoHubRegistration = createRegisterableComponent(
    'video-hub',
    (props: VideoHubRouteProps, services) => {
        const videoData = getVideoInfoFromRouteResolution(services)
        const location = useLocation()
        return (
            <VideoHub
                item={videoData.videoMeta[0]}
                onEvent={services.onEvent}
                config={services.config}
                adUnitPath={String(props.adUnitPath)}
                currentPath={location.pathname}
                verticalGutters={props.verticalGutters}
                verticalSpacing={props.verticalSpacing}
                getVideoQueue={() => {
                    return new Promise((resolve) =>
                        resolve({
                            items: videoData.videoMeta,
                            type: 'topic-related',
                        }),
                    )
                }}
            />
        )
    },
)
